import React from 'react';
import { pdf, Font, Document, Page, Text,View, StyleSheet } from '@react-pdf/renderer';
import cl from './Contract.module.css'
import PDFicon from "../../../../assets/Icon/FileCheck";
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf'; 
import { baseFileURL } from '../../../../Api';
import { useTranslation } from 'react-i18next';



const formatDate = (dateString) => {

    const purchasedAtDate = new Date(dateString);

    const months = [
        "იანვარი",
        "თებერვალი",
        "მარტი",
        "აპრილი",
        "მაისი",
        "ივნისი",
        "ივლისი",
        "აგვისტო",
        "სექტემბერი",
        "ოქტომბერი",
        "ნოემბერი",
        "დეკემბერი"
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day}  ${month}  ${year}`;
};

const formatDateSecond = (dateString) => {

    const purchasedAtDate = new Date(dateString);

    const months = [
        "იანვარს",
        "თებერვალს",
        "მარტს",
        "აპრილს",
        "მაისს",
        "ივნისს",
        "ივლისს",
        "აგვისტოს",
        "სექტემბერს",
        "ოქტომბერს",
        "ნოემბერს",
        "დეკემბერს"
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${year} წლის  ${day} ${month}`;
};

let primaryColor = "#000"
let ltd = "___________________"
let sk = "___________________"
let email = "___________________"
let tel = "032 2 11 12 13"  
let address = "___________________"
let director = "___________________"
let director_pn = "___________________"

if(baseFileURL === 'https://finance.automoby.ge') {
    primaryColor = "#235e82"
    ltd = "შ.პ.ს. „ავტომობი“"
    sk = "446977022" 
    email = "info@automoby.ge" 
    tel = "0322 11 12 13" 
    address = "თბილისი, ც. დადიანის 123/235" 
    director = "ნინო ჩანადირი"
    director_pn = "01024069247"

} else if(baseFileURL === 'https://crm.aig.com.ge') {

    primaryColor = "#da0429" 
    ltd = "შ.პ.ს. „ავტო იმპორტ ჯორჯია“"
    sk = "406203120"
    email = "info@aig.com.ge" 
    tel = "0322 11 12 13" 
    address = "თბილისი, ც.დადიანიანის 123/125" 
    director = "მარიამ აქულაშვილი"
    director_pn = "01011091639"
}

Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});



const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '40px 50px',
        fontSize: '10px',
        lineHeight: 1.5, 
        textAlign: 'justify',
    }, 
    
    p: { 
        marginBottom: '10px',
        textAlign: 'justify',
    }, 
    p0: { 
        marginBottom: '0px',
        textAlign: 'justify',
    }, 
    b: { 
        fontFamily: 'HelveticaBold', 
    }, 

});

 


const MyDocument = ({ car }) => (
    <Document>

        <Page size="A4" style={styles.page}>
 
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px',}}>
                <Text>მიღება-ჩაბარების აქტი</Text> 
            </View>
  
 
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '7px'}}>
                <Text>თბილისი</Text> 
                <Text>{formatDate(new Date().toISOString())}</Text> 
            </View>
  
            <Text style={styles.p}>
                აქტი შედგენილია, ერთის მხრივ {ltd} -ს ადმინისტრაციის დეპარტამენტის
                ხელმძღვანელი, {director} პ.ნ {director_pn} (შემდგომში საქონლის გამყიდველი) და
                მეორეს მხრივ {car.client.firstname} {car.client.lastname} პ.ნ {car.client.personal} (კლიენტი) შორის.
            </Text> 
    
  
            <Text style={styles.p}>
            {formatDateSecond(new Date().toISOString())} საქონლის გამყიდველმა გადასცა, ხოლო საქონლის მყიდველმა მიიღო ხელშეკრულებით გათვალისწინებული საქონელი.
            </Text> 
    
  
            <Text style={styles.p}>
            <Text style={styles.b}>{car.prod_year && car.prod_year}  {car.maker && car.maker.name} {car.model && car.model.name} </Text>
            </Text> 
  
            <Text style={styles.p}>
            <Text style={styles.b}>{car.vin}  </Text>
                
            </Text> 
    
  
            <Text style={styles.p}>
                მიღება ჩაბარების აქტი შედგენილია ორ ეგზემპლარად და არც ერთ მხარეს ურთიერთშორის პრეტენზია არ გააჩნია.
            </Text> 
      
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
               მხარეთა ხელმოწერები
            </Text> 
 
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#fff', padding: '30px 0px'  }}>
 
                <View style={{ width: '50%', padding: '5px 20px 5px 0px', borderRight: '1px solid '+ primaryColor}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>კომპანია </Text>
                    <Text>{ltd}</Text>
                    <Text>ს/ნ:{sk}</Text>
                    <Text>მის: {address}</Text>
                    <Text>ტელ: {tel}</Text>
                    <Text>ელ-ფოსტა: {email}</Text>
                    <Text style={{ textAlign: 'left' }}>ადმინისტრაციული დეპარტამენტის ხელმძღვანელი: <Text style={{ fontFamily: 'HelveticaBold' }}> {director} (პ/ნ:{director_pn})</Text></Text>
                    <Text> </Text>
                    <Text>_______________________________________</Text>

                </View>
  
                <View style={{ width: '50%', paddingLeft: '20px', borderLeft: '1px solid '+ primaryColor}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>კლიენტი </Text>
                    <Text>{car.client.firstname} {car.client.lastname}  </Text>
                    <Text>პ/ნ: {car.client.personal} </Text>
                    <Text>ტელ: {car.client.mobile} </Text>
                    <Text>ელ-ფოსტა: {car.client.email} </Text>
                    <Text> </Text>
                    <Text> </Text>
                    <Text> </Text>
                    <Text> </Text>
                    <Text style={{ marginBottom: '5px' }}> </Text>
                    <Text>_______________________________________</Text>
                 </View>
  
            </View>



        </Page>
 
    </Document>
);

const DeliveryAcceptance = ({ carItem }) => {
    const {t} = useTranslation();
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument car={carItem} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'DeliveryAcceptance.pdf';
        link.click();
    };

    return (
        <span className={cl.btn} onClick={generatePDF}> <PDFicon /> {t('AcceptanceHandover')} </span>
    );
};

export default DeliveryAcceptance;
